import { render, staticRenderFns } from "./button-redirect.vue?vue&type=template&id=a788ffbc"
import script from "./button-redirect.vue?vue&type=script&lang=js"
export * from "./button-redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports